import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "20"}
    height={props.height || "20"}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_222_2372)">
      <mask
        id="mask0_222_2372"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path d="M20 0H0V20H20V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_222_2372)">
        <mask
          id="mask1_222_2372"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path d="M0 1.90735e-06H20V20H0V1.90735e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask1_222_2372)">
          <path
            d="M8.62332 0.585938H11.3764C12.6421 0.585938 13.6925 1.41695 13.8242 2.52219L14.5536 8.64992C14.6097 9.12078 14.4525 9.54492 14.0916 9.89664C13.7308 10.2483 13.2667 10.4297 12.7275 10.4297H7.27223C6.73308 10.4297 6.26898 10.2483 5.90816 9.89664C5.54726 9.54492 5.39008 9.12078 5.44613 8.64992L6.17566 2.52219C6.30723 1.41695 7.35773 0.585938 8.62332 0.585938Z"
            stroke={props.fill || "#4D5F7A"}
            stroke-width="1.5"
            stroke-miterlimit="22.926"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 13.5156V19.4141"
            stroke={props.fill || "#4D5F7A"}
            stroke-width="1.5"
            stroke-miterlimit="22.926"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.15625 10.4297H14.8438C15.6602 10.4297 16.3281 11.0977 16.3281 11.9141C16.3281 12.7305 15.6602 13.3984 14.8438 13.3984H5.15625C4.3398 13.3984 3.67188 12.7305 3.67188 11.9141C3.67188 11.0977 4.3398 10.4297 5.15625 10.4297Z"
            stroke={props.fill || "#4D5F7A"}
            stroke-width="1.5"
            stroke-miterlimit="22.926"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.84375 19.4139V18.5546C4.84375 17.9736 5.31758 17.4998 5.89852 17.4998H14.1014C14.6824 17.4998 15.1562 17.9736 15.1562 18.5546V19.414"
            stroke={props.fill || "#4D5F7A"}
            stroke-width="1.5"
            stroke-miterlimit="22.926"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.7344 8.94532H16.3281V11.6213"
            stroke={props.fill || "#4D5F7A"}
            stroke-width="1.5"
            stroke-miterlimit="22.926"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.26562 8.94532H3.67188V11.6213"
            stroke={props.fill || "#4D5F7A"}
            stroke-width="1.5"
            stroke-miterlimit="22.926"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_222_2372">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
